
export const blogPosts = [
  {
    id: 1,
    title: "The Power of Recording Your Dreams",
    excerpt: "Why writing down your dreams and aspirations is the first step toward making them reality. Discover the spiritual and practical benefits of dream journaling.",
    category: "Personal Growth",
    date: "2024-12-15",
    readTime: "5 min read",
    image: "https://public.readdy.ai/ai/img_res/408eb556ea74a9fd0941eb69dbfa2bf7.jpg"
  },
  {
    id: 2,
    title: "Faith-Based Leadership in Modern Business",
    excerpt: "How to integrate your spiritual values into your professional life without compromise. Leading with integrity in today's business world.",
    category: "Faith & Business",
    date: "2024-12-10",
    readTime: "7 min read",
    image: "https://readdy.ai/api/search-image?query=professional%20business%20meeting%20with%20diverse%20team%2C%20warm%20lighting%2C%20collaborative%20atmosphere%2C%20faith-based%20leadership%20concept%2C%20deep%20blue%20and%20gold%20accents&width=400&height=250&seq=blog2&orientation=landscape"
  },
  {
    id: 3,
    title: "Creating Your Personal Vision Map",
    excerpt: "Step-by-step guide to clarifying your life's direction and creating a roadmap for meaningful achievement. Transform dreams into actionable plans.",
    category: "Purpose",
    date: "2024-12-05",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=vision%20board%20and%20planning%20materials%20on%20desk%2C%20organized%20workspace%2C%20goal-setting%20concept%2C%20inspirational%20atmosphere%2C%20deep%20blue%20and%20gold%20color%20scheme&width=400&height=250&seq=blog3&orientation=landscape"
  },
  {
    id: 4,
    title: "The Art of Reflective Journaling",
    excerpt: "Discover how daily reflection can transform your spiritual life and personal growth. Practical tips for meaningful journaling practice.",
    category: "Journaling",
    date: "2024-11-28",
    readTime: "4 min read",
    image: "https://readdy.ai/api/search-image?query=beautiful%20journal%20open%20on%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20peaceful%20writing%20environment%2C%20spiritual%20reflection%20concept%2C%20warm%20tones&width=400&height=250&seq=blog4&orientation=landscape"
  },
  {
    id: 5,
    title: "Building Resilience Through Faith",
    excerpt: "How spiritual grounding provides the foundation for overcoming life's challenges and emerging stronger from adversity.",
    category: "Faith & Business",
    date: "2024-11-20",
    readTime: "8 min read",
    image: "https://readdy.ai/api/search-image?query=person%20standing%20on%20mountain%20peak%20at%20sunrise%2C%20inspirational%20landscape%2C%20overcoming%20challenges%20concept%2C%20golden%20light%2C%20spiritual%20strength%20theme&width=400&height=250&seq=blog5&orientation=landscape"
  },
  {
    id: 6,
    title: "Effective Communication in Leadership",
    excerpt: "Master the art of inspiring and motivating others through authentic, purpose-driven communication. Connect with your team on a deeper level.",
    category: "Leadership",
    date: "2024-11-15",
    readTime: "6 min read",
    image: "https://readdy.ai/api/search-image?query=confident%20speaker%20addressing%20engaged%20audience%2C%20professional%20conference%20setting%2C%20leadership%20communication%2C%20warm%20lighting%2C%20inspiring%20atmosphere&width=400&height=250&seq=blog6&orientation=landscape"
  }
];
